import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import _ from 'lodash'
import React, { Component } from 'react'

class TagSetFilter extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedTags: this.props.selectedTags && this.props.selectedTags.length > 0 ? [...this.props.selectedTags] : []
    }

    this.updateSelection = this.updateSelection.bind(this)
  }

  updateSelection(tag) {
    const updatedTags = _.clone(this.state.selectedTags)
    if (this.state.selectedTags.includes(tag.id)) {
      const index = updatedTags.indexOf(tag.id)
      updatedTags.splice(index, 1)
    } else {
      updatedTags.push(tag.id)
    }
    this.setState({ selectedTags: updatedTags })
    this.props.updateFilter(updatedTags)
  }

  componentDidUpdate(prevProps) {
    const selectedTags = this.props.selectedTags || []
    if (!_.isEqual(prevProps.selectedTags || [], selectedTags) && !_.isEqual(this.state.selectedTags, selectedTags)) {
      this.setState({ selectedTags: [...selectedTags] })
    }
  }

  render() {
    const sortedTags = _.cloneDeep(this.props.tagSet.portal_tags)
    sortedTags.sort((a, b) => a.order - b.order)
    return (
      <div>
        {sortedTags.map(tag => {
          return (
            <div key={tag.id}>
              <div className="individual-category">
                <FormControlLabel
                  control={
                    <Checkbox
                      name="selected_category"
                      id="selected_category"
                      className="selected_category"
                      checked={this.state.selectedTags.includes(tag.id)}
                      onChange={() => this.updateSelection(tag)}
                    />
                  }
                  label={tag.name}
                />
              </div>
            </div>
          )
        })}
      </div>
    )
  }
}

export default TagSetFilter
